// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.font_size {
  font-size: 12px !important;
}

.ng-autocompleteroutr {
  width: 370px;
}

.search_btnss {
  background-color: #17a2b8;
  color: white;
  border: none;
  outline: none;
}

.reset_btnss {
  background-color: #17a2b8;
  color: white;
  border: none;
}

.link_Nonhighlight {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
}

.link_highlight {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
  margin-right: 1%;
}

.link_highlight:hover {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
  background-color: #3fa4fb;
  padding-inline: 3%;
  padding-block: 2px;
  border-radius: 12px;
  color: white !important;
  cursor: pointer;
}

.iconCheck {
  font-size: 12px;
  position: relative;
  top: -20%;
  margin-left: -3px;
}

.doller {
  position: absolute;
  top: -11px;
  left: 15%;
}

.textCenter {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.text-success {
  color: #5dd077 !important;
}

.text-danger {
  color: #da606c !important;
}

.gui_ellipsis {
  font-weight: 600;
  max-width: 92%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}

.pipeline_ellipsis {
  max-width: 89%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  position: relative;
  top: 8%;
  left: 1%;
  padding-right: 1%;
}

.trans_ellipsis {
  max-width: 74%;
  white-space: nowrap;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  padding-right: 1%;
}

.active_card {
  border-left: 4px solid #07a36e;
}

.progress_card {
  border-left: 4px solid #ffc107;
}

.iconPointer:hover {
  pointer-events: all;
}

.arrow_source {
  left: 5%;
  width: 97%;
  height: 2px;
  background-color: grey;
  position: relative;
  top: 36%;
}

.arr_chev {
  position: relative;
  text-align: right !important;
  right: -98%;
  color: grey;
  top: -9px;
}

.failed_card {
  border-left: 4px solid #da606c;
}

.primary_card {
  border-left: 4px solid #007bff;
}

.healing_card {
  border-left: 4px solid #f5a700;
}

.ignored_card {
  border-left: 4px solid rgba(128, 128, 128, 0.6901960784);
}

.border-gradient {
  border-left: 4px solid !important;
  border-image-slice: 1;
  border-block: 0;
  border-right: 0;
}

.border-gradient-redgreen {
  border-image-source: linear-gradient(to bottom, #db6c6c, #22ed86);
}

.copy_icon {
  margin-left: 2%;
  cursor: pointer;
  font-size: 15px;
}

.pipeline_label {
  float: left;
  padding-right: 11%;
  position: relative;
  top: 8px;
}

.pipeline_feild {
  float: left;
  width: 100%;
}

.source_label {
  float: left;
  padding-right: 9%;
  position: relative;
  top: 8px;
}

.source_feild {
  float: left;
  width: 100%;
}

.target_label {
  float: left;
  padding-right: 13%;
  position: relative;
  top: 8px;
}

.target_feild {
  float: left;
  width: 100%;
}

.processor_label {
  float: left;
  padding-right: 7%;
  position: relative;
  top: 8px;
}

.processor_feild {
  float: left;
  width: 100%;
}

.message_label {
  float: left;
  padding-right: 9%;
  position: relative;
  top: 8px;
}

.message_feild {
  float: left;
  width: 100%;
}

.transaction_label {
  float: left;
  padding-right: 3%;
  position: relative;
  top: 8px;
}

.message_type_label {
  float: left;
  padding-right: 3%;
  position: relative;
  top: 8px;
}

.message_type_feild {
  width: 100%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  top: -6px;
}

.message_type_label {
  float: left;
  padding-right: 2%;
  position: relative;
  top: 8px;
}

.message_type {
  width: 100%;
  height: 30px;
  position: relative;
}

.messagefield_label {
  float: left;
  padding-right: 2%;
  position: relative;
  top: 8px;
}

.messagefield_feild {
  float: left;
  width: 100%;
}

.btnsdiv {
  padding-left: 16%;
}

@media screen and (min-width: 900px) and (max-width: 1024px) {
  .pipeline_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 8px;
  }
  .target_label {
    float: left;
    padding-right: 9%;
    position: relative;
    top: 8px;
  }
  .processor_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 8px;
    font-size: 12px;
    font-weight: 700;
  }
  .processor_feild {
    float: left;
    width: 100%;
  }
  .message_label {
    float: left;
    padding-right: 1%;
    position: relative;
    top: 8px;
  }
  .transaction_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 8px;
  }
  .message_type {
    width: 53%;
    height: 35px;
    position: relative;
  }
  .message_type_margin {
    margin-left: 1% !important;
  }
  .pipeline_ellipsis {
    max-width: 85%;
  }
  .trans_ellipsis {
    max-width: 65%;
  }
  .message_btns span {
    padding: 0 !important;
  }
}
@media screen and (min-width: 500px) and (max-width: 786px) {
  .pipeline_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 0px;
  }
  .pipeline_feild {
    float: left;
    width: 100%;
  }
  .source_label {
    float: left;
    padding-right: 6%;
    position: relative;
    top: 0px;
  }
  .source_feild {
    float: left;
    width: 100%;
  }
  .target_label {
    float: left;
    padding-right: 9%;
    position: relative;
    top: 0px;
  }
  .target_feild {
    float: left;
    width: 100%;
  }
  .processor_label {
    float: left;
    padding-right: 1%;
    position: relative;
    top: 0px;
    font-size: 12px;
    font-weight: 700;
  }
  .processor_feild {
    float: left;
    width: 100%;
  }
  .message_label {
    float: left;
    padding-right: 1%;
    position: relative;
    top: 0px;
  }
  .message_feild {
    float: left;
    width: 100%;
  }
  .transaction_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 0px;
  }
  .message_type {
    width: 86%;
    height: 35px;
    position: relative;
  }
  .reset_btn {
    padding-inline: 13% !important;
  }
  .gui_ellipsis {
    font-weight: 600;
    width: 65%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .message_type_margin {
    margin-left: 1% !important;
  }
  .pipeline_ellipsis {
    max-width: 81%;
  }
  .trans_ellipsis {
    max-width: 52%;
  }
  .message_btns span {
    padding: 0 !important;
  }
}
.rightalign {
  float: right;
  padding-right: 60px;
  padding-top: 10px;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline {
  height: 0px !important;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {
  top: 0;
  height: 0px !important;
  overflow: hidden;
}

.text-green {
  color: green;
}

.text-red {
  color: red;
}

::ng-deep.pipeSearch_messages .autocomplete-container .suggestions-container {
  position: absolute;
  background: #fff;
  height: auto;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  font-size: 14px;
}

::ng-deep.messageiot .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.messageiot {
  top: 4% !important;
}

::ng-deep.messageioteditor .editor-container {
  overflow: hidden !important;
  position: relative !important;
  display: table !important;
  width: 100% !important;
  height: 99% !important;
  min-width: 0 !important;
}

::ng-deep.messageiot .modal-dialog .modal-content .modal-footer {
  display: unset !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  justify-content: flex-end !important;
  border-top: 1px solid #dee2e6 !important;
  border-bottom-right-radius: calc(0.3rem - 1px) !important;
  border-bottom-left-radius: calc(0.3rem - 1px) !important;
}

.date_control_style {
  width: 100%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 2%;
}

.autocomplete-container .suggestions-container {
  position: absolute;
  background: #fff;
  height: auto;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  font-size: 14px;
}

::ng-deep.fonts_bulkreprocess .autocomplete-container .suggestions-container {
  position: absolute;
  background: #fff;
  height: auto;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  font-size: 14px;
}

.messagestatus {
  position: relative;
  top: -3px;
}

.transaction_feild {
  float: left;
  font-size: 12px !important;
  height: 9.5vh;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  width: 100%;
}

.transaction_feild2 {
  float: left;
  font-size: 12px !important;
  height: 5vh;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  width: 100%;
}

.inIcon {
  position: relative;
  top: -15%;
}

::ng-deep.mirth_transaction_style .mat-content {
  display: block !important;
}

::ng-deep.mirth_transaction_style {
  transform: none !important;
  height: 65vh !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

::ng-deep.Mode_Boot .modal-dialog {
  max-width: 97% !important;
  max-height: 100% !important;
  height: 100% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.Mode_Boot {
  top: 3% !important;
  font-family: montserrat;
  font-size: 12px;
}
::ng-deep.Mode_Boot strong {
  font-weight: 600 !important;
}

.fieldstyle {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  border-radius: 5px !important;
  border: transparent;
  width: 98% !important;
  min-height: 50px !important;
  max-height: 50px !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  background-color: white !important;
}

.examplechiplist mat-form-field.mat-form-field.mat-form-field-appearance-fill > div.mat-form-field-wrapper > div.mat-form-field-flex > div.mat-form-field-infix {
  padding-inline: 5px;
  padding-block: 1px;
  padding-top: 0px !important;
  min-height: 40px !important;
}

.examplechiplist mat-form-field.mat-form-field.mat-form-field-appearance-fill > div.mat-form-field-wrapper > div.mat-form-field-flex > div.mat-form-field-infix > mat-chip-list.mat-chip-list {
  display: inline-block;
}

.examplechiplist .mat-form-field-appearance-fill.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {
  transform: translateY(-1.1em) scale(0.75);
  width: 133.33333%;
}

::ng-deep.examplechiplist .mat-form-field-infix .mat-chip-list-wrapper {
  padding-top: 15px !important;
  float: left;
}

::ng-deep.examplechiplist2 .mat-mdc-form-field-infix .mat-chip-list-wrapper {
  padding-top: 0px !important;
  float: left;
}

::ng-deep.examplechiplist2 .mat-form-field-appearance-legacy .mat-mdc-text-field-wrapper {
  margin-top: -1% !important;
  margin-left: 2% !important;
  padding-bottom: 0px !important;
}

::ng-deep.examplechiplist .mat-form-field-appearance-legacy .mat-mdc-text-field-wrapper {
  margin-top: -3% !important;
  margin-left: 2% !important;
  padding-bottom: 0px !important;
}

.matchipinputfield input.mat-chip-input {
  width: 150px;
  margin: 4px;
  flex: 1 0 150px;
}

.matchipinputfield2 input.mat-chip-input {
  width: 150px;
  margin: 4px;
  flex: 1 0 150px;
}

.message_feild2 {
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  width: 100%;
  float: left;
  height: 5vh;
  font-size: 12px !important;
}

.textFeid {
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  width: 100%;
  height: 16.5vh;
  font-size: 12px !important;
}

.message_feild1 {
  float: left;
  font-size: 12px !important;
  height: 9.5vh;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  width: 100%;
}

.message_feild3 {
  float: left;
  font-size: 12px !important;
  height: 15.8vh;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  width: 100%;
}

.card_HeightExp {
  max-height: 34vh;
  min-height: 34vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.card_HeightCol {
  max-height: 57vh;
  min-height: 57vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.view-btn-details {
  position: absolute;
  left: 57%;
  width: 84px;
}

::ng-deep .PopupScreen .modal-dialog {
  max-width: 80% !important;
  max-height: 50px !important;
  padding: 0 !important;
  display: flex !important;
  justify-content: center !important;
}

::ng-deep.myCustomModalViewfile .modal-dialog {
  max-width: 80% !important;
  max-height: 60% !important;
  height: 60% !important;
  padding: 0 !important;
  display: flex !important;
  justify-content: center !important;
}

::ng-deep.archivecheck.mat-mdc-checkbox .mdc-checkbox {
  width: 14px;
  height: 14px;
  padding-right: 6px;
  bottom: 4px;
}
::ng-deep.archivecheck.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #17a0b4 !important;
  background-color: #17a0b4 !important;
}
::ng-deep.archivecheck.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: white;
}
::ng-deep.archivecheck.mat-mdc-checkbox .mdc-checkbox__background {
  height: 16px;
  width: 16px;
}
::ng-deep.archivecheck.mat-mdc-checkbox .mdc-form-field > label {
  padding-right: 10px;
}

::ng-deep.msgrep.mat-mdc-checkbox {
  height: 16px;
  width: 16px;
  position: relative;
  right: 3%;
  bottom: 9%;
}
::ng-deep.msgrep.mat-mdc-checkbox .mdc-checkbox {
  width: 16px;
  height: 16px;
}
::ng-deep.msgrep.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #17a0b4 !important;
  background-color: #17a0b4 !important;
}
::ng-deep.msgrep.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: white;
}
::ng-deep.msgrep.mat-mdc-checkbox .mdc-checkbox__background {
  height: 16px;
  width: 16px;
}

::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox {
  width: 16px;
  height: 16px;
}
::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #17a0b4 !important;
  background-color: #17a0b4 !important;
}
::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: white;
}
::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox__background {
  height: 16px !important;
  width: 16px !important;
}

.copylabel {
  position: relative;
  bottom: 8px;
}

::ng-deep.messageioteditor .editor-container .monaco-editor {
  width: 100% !important;
}
::ng-deep.messageioteditor .editor-container .monaco-editor .overflow-guard {
  width: 100% !important;
}
::ng-deep.messageioteditor .editor-container .monaco-editor .overflow-guard .monaco-scrollable-element.editor-scrollable {
  width: 85% !important;
}

::ng-deep.messageioteditormax .editor-container .monaco-editor {
  width: 100% !important;
}
::ng-deep.messageioteditormax .editor-container .monaco-editor .overflow-guard {
  width: 100% !important;
}
::ng-deep.messageioteditormax .editor-container .monaco-editor .overflow-guard .monaco-scrollable-element.editor-scrollable {
  width: 92% !important;
}

::ng-deep.viewstages .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.viewstages {
  top: 4% !important;
}

::ng-deep.viewstages {
  top: 4% !important;
  font-family: "Montserrat", sans-serif;
  font-size: 11px;
}
::ng-deep.viewstages strong {
  font-weight: 600 !important;
}

.button-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;
  padding: 10px;
  width: 100%;
}

.icon-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  color: #4caf50;
  border: none;
  cursor: pointer;
  position: relative;
  transition: transform 0.2s;
}

.icons_list_style {
  background-color: transparent;
}

.icons_list_style_active {
  background-color: transparent;
}

.icon-button.icons_list_style_active::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 0;
  right: 0;
  height: 3px;
  background-color: #00bcd4;
  border-radius: 5px;
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mirthsuc {
  font-weight: normal;
  display: inline;
  margin-left: 2px;
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.col-sm-4 {
  padding: 10px;
}

.div-message-attributes {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  color: black;
}

.mt-minus-3 {
  margin-top: -2vh;
}

.icon-style {
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  margin-top: -9px;
  margin-right: 16px;
  font-size: 27px;
}

.icon-styles {
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 2px;
  margin-top: -12px;
  margin-right: 16px;
  height: 20px;
  width: 20px;
}

.icon-ack {
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 2px;
  margin-top: -6px;
  margin-right: 15px;
  height: 25px;
  width: 22px;
}

.icon-hold {
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 2px;
  margin-top: 3px;
  margin-right: 16px;
  font-size: 21px;
  width: 20px;
}

.clickable-div {
  cursor: pointer;
}

.clickable-div button,
.clickable-div mat-icon,
.clickable-div i,
.clickable-div img,
.clickable-div svg,
.clickable-div td {
  cursor: pointer !important;
}

.redirectlink {
  white-space: nowrap;
  position: relative;
  z-index: 1000;
  color: #4b86b2;
}

.redirectlink:hover {
  background-color: #3fa4fb;
  border-radius: 12px;
  color: white;
  padding: 3px;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  z-index: 1000;
}

.childexpcard {
  background-color: #f9f9f9;
  margin-bottom: 0;
  padding-top: 5px;
  min-height: 13vh;
  max-height: 23vh;
  overflow-x: hidden;
  overflow-y: auto;
}

::ng-deep.main_page_paginator .mat-mdc-paginator-container {
  min-height: 40px !important;
  max-height: 40px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/hubmessages/hubmessages.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACE,0BAAA;AADF;;AAKA;EACE,YAAA;AAFF;;AAIA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;AADF;;AAIA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;AADF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AAAF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAGA;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;AAAF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AACF;;AACA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAEF;;AAAA;EACE,yBAAA;AAGF;;AADA;EACE,yBAAA;AAIF;;AADA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;AAIF;;AADA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;AAIF;;AADA;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EAEA,iBAAA;AAGF;;AADA;EACE,8BAAA;AAIF;;AAFA;EACE,8BAAA;AAKF;;AAHA;EACE,mBAAA;AAMF;;AAJA;EACE,QAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;AAOF;;AALA;EACE,kBAAA;EACA,4BAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;AAQF;;AANA;EACE,8BAAA;AASF;;AAPA;EACE,8BAAA;AAUF;;AARA;EACE,8BAAA;AAWF;;AATA;EACE,wDAAA;AAYF;;AAVA;EACE,iCAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AAaF;;AAXA;EACE,iEAAA;AAcF;;AAZA;EACE,eAAA;EACA,eAAA;EACA,eAAA;AAeF;;AAZA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AAeF;;AAbA;EACE,WAAA;EACA,WAAA;AAgBF;;AAbA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAgBF;;AAdA;EACE,WAAA;EACA,WAAA;AAiBF;;AAdA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AAiBF;;AAfA;EACE,WAAA;EACA,WAAA;AAkBF;;AAfA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAkBF;;AAhBA;EACE,WAAA;EACA,WAAA;AAmBF;;AAjBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAoBF;;AAlBA;EACE,WAAA;EACA,WAAA;AAqBF;;AAlBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAqBF;;AAnBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAsBF;;AAnBA;EACE,WAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAsBF;;AApBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAuBF;;AArBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAwBF;;AArBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAwBF;;AAtBA;EACE,WAAA;EACA,WAAA;AAyBF;;AAtBA;EACE,iBAAA;AAyBF;;AAtBA;EACE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAyBF;EAtBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAwBF;EAtBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;IACA,eAAA;IACA,gBAAA;EAwBF;EAtBA;IACE,WAAA;IACA,WAAA;EAwBF;EArBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAuBF;EApBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAsBF;EApBA;IACE,UAAA;IACA,YAAA;IACA,kBAAA;EAsBF;EApBA;IACE,0BAAA;EAsBF;EApBA;IACE,cAAA;EAsBF;EApBA;IACE,cAAA;EAsBF;EAnBE;IACE,qBAAA;EAqBJ;AACF;AAjBA;EACE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAmBF;EAhBA;IACE,WAAA;IACA,WAAA;EAkBF;EAhBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAkBF;EAhBA;IACE,WAAA;IACA,WAAA;EAkBF;EAhBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAkBF;EAhBA;IACE,WAAA;IACA,WAAA;EAkBF;EAhBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;IACA,eAAA;IACA,gBAAA;EAkBF;EAhBA;IACE,WAAA;IACA,WAAA;EAkBF;EAfA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAiBF;EAfA;IACE,WAAA;IACA,WAAA;EAiBF;EAfA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAiBF;EAfA;IACE,UAAA;IACA,YAAA;IACA,kBAAA;EAiBF;EAdA;IACE,8BAAA;EAgBF;EAbA;IACE,gBAAA;IACA,UAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;EAeF;EAbA;IACE,0BAAA;EAeF;EAbA;IACE,cAAA;EAeF;EAbA;IACE,cAAA;EAeF;EAZE;IACE,qBAAA;EAcJ;AACF;AARA;EACE,YAAA;EACA,mBAAA;EACA,iBAAA;AAUF;;AANA;EACE,sBAAA;AASF;;AANA;EACE,MAAA;EACA,sBAAA;EACA,gBAAA;AASF;;AANA;EACE,YAAA;AASF;;AAPA;EACE,UAAA;AAUF;;AAPA;EACE,kBAAA;EAEA,gBAAA;EACA,YAAA;EACA,yCAAA;EACA,sBAAA;EACA,eAAA;AASF;;AANA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AASF;;AAPA;EACE,kBAAA;AAUF;;AAPA;EACE,2BAAA;EACE,6BAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;AAUJ;;AAPA;EACE,yBAAA;EACA,0BAAA;EACE,8BAAA;EACA,oCAAA;EAEA,wCAAA;EACA,yDAAA;EACA,wDAAA;AASJ;;AANA;EACE,WAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;AASF;;AANA;EACE,kBAAA;EAEA,gBAAA;EACA,YAAA;EACA,yCAAA;EACA,sBAAA;EACA,eAAA;AAQF;;AALA;EACE,kBAAA;EAEA,gBAAA;EACA,YAAA;EACA,yCAAA;EACA,sBAAA;EACA,eAAA;AAOF;;AAJA;EACE,kBAAA;EACE,SAAA;AAOJ;;AALA;EACE,WAAA;EACA,0BCxgBS;EDygBT,aAAA;EACA,kBAAA;EACA,oDAAA;EACE,WAAA;AAQJ;;AANA;EACE,WAAA;EACA,0BChhBS;EDihBT,WAAA;EACA,kBAAA;EACA,oDAAA;EACE,WAAA;AASJ;;AA8BA;EACE,kBAAA;EACA,SAAA;AA3BF;;AA+BA;EACE,yBAAA;AA5BF;;AA8BA;EACE,0BAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;AA3BF;;AA8BA;EACE,yBAAA;EACA,2BAAA;EACA,uBAAA;EACA,uBAAA;EACA,qBAAA;AA3BF;;AA6BA;EACE,kBAAA;EACA,uBAAA;EACA,eAAA;AA1BF;AA2BE;EACE,2BAAA;AAzBJ;;AA4BA;EACE,yCAAA;EAAwC,6BAAA;EAAkC,mBAAA;EAC1E,qBAAA;EACA,2BAAA;EACA,2BAAA;EACA,6BAAA;EACA,2BAAA;EACA,kCAAA;AAvBF;;AAyBE;EACE,mBAAA;EACE,kBAAA;EACA,2BAAA;EACA,2BAAA;AAtBN;;AAuBE;EAEG,qBAAA;AArBL;;AAwBE;EACI,yCAAA;EACA,iBAAA;AArBN;;AAuBE;EACE,4BAAA;EACA,WAAA;AApBJ;;AAsBE;EACE,2BAAA;EACA,WAAA;AAnBJ;;AAqBE;EACE,0BAAA;EACA,0BAAA;EACC,8BAAA;AAlBL;;AAoBE;EACE,0BAAA;EACA,0BAAA;EACC,8BAAA;AAjBL;;AAmBA;EACE,YAAA;EACA,WAAA;EACF,eAAA;AAhBA;;AAkBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;AAfF;;AAiBA;EACE,kBAAA;EACA,oDAAA;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,0BCnpBO;ADqoBX;;AAgBA;EACE,kBAAA;EACA,oDAAA;EACE,WAAA;EACA,cAAA;EACA,0BC1pBO;AD6oBX;;AAgBA;EACE,WAAA;EACA,0BC/pBS;EDgqBT,aAAA;EACA,kBAAA;EACA,oDAAA;EACE,WAAA;AAbJ;;AAeA;EACE,WAAA;EACA,0BCvqBS;EDwqBT,cAAA;EACA,kBAAA;EACA,oDAAA;EACA,WAAA;AAZF;;AAcA;EAEE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAZF;;AAcA;EAEE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAZF;;AAcA;EAEE,kBAAA;EACA,SAAA;EACA,WAAA;AAZF;;AAcA;EACE,yBAAA;EACA,2BAAA;EACA,qBAAA;EACA,wBAAA;EAAyB,kCAAA;AAV3B;;AAYA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,qBAAA;EACA,wBAAA;EAAyB,kCAAA;AAR3B;;AAcE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAXJ;AAYI;EACE,gCCztBM;ED0tBN,oCC1tBM;ADgtBZ;AAYI;EACE,YAAA;AAVN;AAaE;EACE,YAAA;EACA,WAAA;AAXJ;AAaE;EACE,mBAAA;AAXJ;;AAeA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAZF;AAaE;EACE,WAAA;EACA,YAAA;AAXJ;AAYI;EACE,gCCnvBM;EDovBN,oCCpvBM;AD0uBZ;AAYI;EACE,YAAA;AAVN;AAaE;EACE,YAAA;EACA,WAAA;AAXJ;;AAeE;EACE,WAAA;EACA,YAAA;AAZJ;AAaI;EACE,gCCpwBM;EDqwBN,oCCrwBM;AD0vBZ;AAaI;EACE,YAAA;AAXN;AAcE;EACE,uBAAA;EACA,sBAAA;AAZJ;;AAeA;EACE,kBAAA;EACE,WAAA;AAZJ;;AAgBE;EACE,sBAAA;AAbJ;AAcI;EACE,sBAAA;AAZN;AAaM;EACE,qBAAA;AAXR;;AAiBE;EACE,sBAAA;AAdJ;AAeI;EACE,sBAAA;AAbN;AAcM;EACE,qBAAA;AAZR;;AAiBA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAdF;;AAgBA;EACE,kBAAA;AAbF;;AAeA;EACE,kBAAA;EACA,qCAAA;EACA,eAAA;AAZF;AAcE;EACE,2BAAA;AAZJ;;AAeA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;AAZF;;AAeA;EACE,6BAAA;AAZF;;AAeA;EACE,6BAAA;AAZF;;AAeA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AAZF;;AAeA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAZF;;AAeA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAZF;;AAeA;EACE,aAAA;AAZF;;AAeA;EACE,aAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AAZF;;AAcA;EACE,gBAAA;AAXF;;AAeA;EACE,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAZF;;AAgBA;EACE,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAbF;;AAgBA;EACE,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAbF;;AAgBA;EACE,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AAbF;;AAgBA;EACE,eAAA;AAbF;;AAgBA;;;;;;EAME,0BAAA;AAbF;;AAeA;EACE,mBAAA;EAAsB,kBAAA;EAAoB,aAAA;EAC1C,cAAA;AAVF;;AAYA;EACE,yBAAA;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EAAoB,aAAA;AARxB;;AAUA;EACE,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAPF;;AAUE;EACE,2BAAA;EACA,2BAAA;AAPJ","sourcesContent":["@import \"../../variables.scss\";\r\n\r\n.font_size{\r\n  font-size: 12px !important;\r\n}\r\n\r\n\r\n.ng-autocompleteroutr {\r\n  width: 370px;\r\n}\r\n.search_btnss {\r\n  background-color: #17a2b8;\r\n  color: white;\r\n  border: none;\r\n  outline: none;\r\n}\r\n\r\n.reset_btnss {\r\n  background-color: #17a2b8;\r\n  color: white;\r\n  border: none;\r\n}\r\n.link_Nonhighlight{\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 90% !important;\r\n  display: inline-block;\r\n}\r\n\r\n.link_highlight{\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 90% !important;\r\n  display: inline-block;\r\n  margin-right: 1%;\r\n}\r\n.link_highlight:hover{\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 90% !important;\r\n  display: inline-block;\r\n  background-color: #3fa4fb;\r\n  padding-inline: 3%;\r\n  padding-block: 2px;\r\n  border-radius: 12px;\r\n  color: white !important;\r\n  cursor: pointer;\r\n\r\n}\r\n\r\n.iconCheck {\r\n  font-size: 12px;\r\n  position: relative;\r\n  top: -20%;\r\n  margin-left: -3px;\r\n}\r\n.doller {\r\n  position: absolute;\r\n  top: -11px;\r\n  left: 15%;\r\n}\r\n.textCenter {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n.text-success {\r\n  color: #5dd077 !important;\r\n}\r\n.text-danger {\r\n  color: #da606c !important;\r\n}\r\n\r\n.gui_ellipsis {\r\n  font-weight: 600;\r\n  max-width: 92%;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  display: inline-block;\r\n}\r\n\r\n.pipeline_ellipsis {\r\n  max-width: 89%;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  display: inline-block;\r\n  position: relative;\r\n  top: 8%;\r\n  left: 1%;\r\n  padding-right: 1%;\r\n}\r\n\r\n.trans_ellipsis {\r\n  max-width: 74%;\r\n  white-space: nowrap;\r\n  display: inline-block;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  position: relative;\r\n  // top: 11%;\r\n  padding-right: 1%;\r\n}\r\n.active_card {\r\n  border-left: 4px solid #07a36e;\r\n}\r\n.progress_card {\r\n  border-left: 4px solid #ffc107;\r\n}\r\n.iconPointer:hover {\r\n  pointer-events: all;\r\n}\r\n.arrow_source {\r\n  left: 5%;\r\n  width: 97%;\r\n  height: 2px;\r\n  background-color: grey;\r\n  position: relative;\r\n  top: 36%;\r\n}\r\n.arr_chev {\r\n  position: relative;\r\n  text-align: right !important;\r\n  right: -98%;\r\n  color: grey;\r\n  top: -9px;\r\n}\r\n.failed_card {\r\n  border-left: 4px solid #da606c;\r\n}\r\n.primary_card {\r\n  border-left: 4px solid #007bff;\r\n}\r\n.healing_card {\r\n  border-left: 4px solid  #f5a700;\r\n}\r\n.ignored_card{\r\n  border-left: 4px solid #808080b0;\r\n}\r\n.border-gradient {\r\n  border-left: 4px solid !important;\r\n  border-image-slice: 1;\r\n  border-block: 0;\r\n  border-right: 0;\r\n}\r\n.border-gradient-redgreen {\r\n  border-image-source: linear-gradient(to bottom, #db6c6c, #22ed86);\r\n}\r\n.copy_icon {\r\n  margin-left: 2%;\r\n  cursor: pointer;\r\n  font-size: 15px;\r\n}\r\n\r\n.pipeline_label {\r\n  float: left;\r\n  padding-right: 11%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.pipeline_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.source_label {\r\n  float: left;\r\n  padding-right: 9%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.source_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.target_label {\r\n  float: left;\r\n  padding-right: 13%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.target_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.processor_label {\r\n  float: left;\r\n  padding-right: 7%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.processor_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n.message_label {\r\n  float: left;\r\n  padding-right: 9%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.message_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.transaction_label {\r\n  float: left;\r\n  padding-right: 3%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.message_type_label {\r\n  float: left;\r\n  padding-right: 3%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n\r\n.message_type_feild {\r\n  width: 100%;\r\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  top: -6px;\r\n}\r\n.message_type_label {\r\n  float: left;\r\n  padding-right: 2%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.message_type {\r\n  width: 100%;\r\n  height: 30px;\r\n  position: relative;\r\n}\r\n\r\n.messagefield_label {\r\n  float: left;\r\n  padding-right: 2%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.messagefield_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.btnsdiv {\r\n  padding-left: 16%;\r\n}\r\n\r\n@media screen and (min-width: 900px) and (max-width: 1024px) {\r\n  .pipeline_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n\r\n  .target_label {\r\n    float: left;\r\n    padding-right: 9%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n  .processor_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 8px;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n  }\r\n  .processor_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n\r\n  .message_label {\r\n    float: left;\r\n    padding-right: 1%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n\r\n  .transaction_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n  .message_type {\r\n    width: 53%;\r\n    height: 35px;\r\n    position: relative;\r\n  }\r\n  .message_type_margin {\r\n    margin-left: 1% !important;\r\n  }\r\n  .pipeline_ellipsis {\r\n    max-width: 85%;\r\n  }\r\n  .trans_ellipsis {\r\n    max-width: 65%;\r\n  }\r\n  .message_btns {\r\n    span {\r\n      padding: 0 !important;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 500px) and (max-width: 786px) {\r\n  .pipeline_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 0px;\r\n  }\r\n\r\n  .pipeline_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n  .source_label {\r\n    float: left;\r\n    padding-right: 6%;\r\n    position: relative;\r\n    top: 0px;\r\n  }\r\n  .source_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n  .target_label {\r\n    float: left;\r\n    padding-right: 9%;\r\n    position: relative;\r\n    top: 0px;\r\n  }\r\n  .target_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n  .processor_label {\r\n    float: left;\r\n    padding-right: 1%;\r\n    position: relative;\r\n    top: 0px;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n  }\r\n  .processor_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n\r\n  .message_label {\r\n    float: left;\r\n    padding-right: 1%;\r\n    position: relative;\r\n    top: 0px;\r\n  }\r\n  .message_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n  .transaction_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 0px;\r\n  }\r\n  .message_type {\r\n    width: 86%;\r\n    height: 35px;\r\n    position: relative;\r\n  }\r\n\r\n  .reset_btn {\r\n    padding-inline: 13% !important;\r\n  }\r\n\r\n  .gui_ellipsis {\r\n    font-weight: 600;\r\n    width: 65%;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n  .message_type_margin {\r\n    margin-left: 1% !important;\r\n  }\r\n  .pipeline_ellipsis {\r\n    max-width: 81%;\r\n  }\r\n  .trans_ellipsis {\r\n    max-width: 52%;\r\n  }\r\n  .message_btns {\r\n    span {\r\n      padding: 0 !important;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n.rightalign {\r\n  float: right;\r\n  padding-right: 60px;\r\n  padding-top: 10px;\r\n}\r\n\r\n\r\n::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline{\r\n  height: 0px !important;\r\n}\r\n\r\n::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {\r\n  top: 0;\r\n  height: 0px !important;\r\n  overflow: hidden;\r\n}\r\n\r\n.text-green{\r\n  color:green\r\n}\r\n.text-red{\r\n  color:red;\r\n}\r\n\r\n::ng-deep.pipeSearch_messages .autocomplete-container .suggestions-container {\r\n  position: absolute;\r\n  // width: 170% !important;\r\n  background: #fff;\r\n  height: auto;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%);\r\n  box-sizing: border-box;\r\n  font-size: 14px;\r\n}\r\n\r\n::ng-deep.messageiot .modal-dialog {\r\n  max-width: 97%!important;\r\n  max-height: 60%!important;\r\n  height: 60%!important;\r\n  margin: auto!important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.messageiot{\r\n  top: 4%!important;\r\n}\r\n\r\n::ng-deep.messageioteditor .editor-container{\r\n  overflow: hidden!important;\r\n    position: relative!important;\r\n    display: table!important;\r\n    width: 100%!important;\r\n    height: 99%!important;\r\n    min-width: 0!important;\r\n}\r\n\r\n::ng-deep.messageiot .modal-dialog .modal-content .modal-footer{\r\n  display: unset!important;\r\n  flex-wrap: wrap!important;\r\n    align-items: center!important;\r\n    justify-content: flex-end!important;\r\n\r\n    border-top: 1px solid #dee2e6!important;\r\n    border-bottom-right-radius: calc(0.3rem - 1px)!important;\r\n    border-bottom-left-radius: calc(0.3rem - 1px)!important;\r\n}\r\n\r\n.date_control_style{\r\n  width: 100%;\r\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 2%;\r\n  // padding-block: 3%;\r\n}\r\n.autocomplete-container .suggestions-container {\r\n  position: absolute;\r\n\r\n  background: #fff;\r\n  height: auto;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%);\r\n  box-sizing: border-box;\r\n  font-size: 14px;\r\n}\r\n\r\n::ng-deep.fonts_bulkreprocess .autocomplete-container .suggestions-container {\r\n  position: absolute;\r\n  // width: 170%;\r\n  background: #fff;\r\n  height: auto;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%);\r\n  box-sizing: border-box;\r\n  font-size: 14px;\r\n}\r\n\r\n.messagestatus{\r\n  position: relative;\r\n    top: -3px;\r\n}\r\n.transaction_feild{\r\n  float: left;\r\n  font-size: $fontsize;\r\n  height: 9.5vh;\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    width: 100%;\r\n}\r\n.transaction_feild2{\r\n  float: left;\r\n  font-size: $fontsize;\r\n  height: 5vh;\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    width: 100%;\r\n}\r\n// .hubmessageList{\r\n//   ::ng-deep .mat-ink-bar {\r\n//     background-color: rgba(0, 0, 0, 0) !important;\r\n//   }\r\n\r\n//   ::ng-deep .mat-tab-label {\r\n//     // background-color: rgb(238, 180, 23) !important;\r\n//     height: 30px  !important;\r\n//     opacity:unset !important;\r\n//     padding-inline: 1% !important;\r\n//   }\r\n\r\n//   ::ng-deep .mat-tab-label.mat-tab-label-active {\r\n//     min-width: 25px !important;\r\n//     padding: 5px 10px;\r\n//       background-color: #12127c;\r\n//       color: white;\r\n//       font-weight: 700;\r\n//       opacity: unset;\r\n//       border-top-left-radius: 5px;\r\n//       border-top-right-radius: 5px;\r\n//   }\r\n//   ::ng-deep .mat-tab-label {\r\n//     min-width: 25px !important;\r\n//     padding: 5px;\r\n//     background-color: transparent;\r\n//     color: black;\r\n//     font-weight: 700;\r\n//   }\r\n// }\r\n\r\n// ::ng-deep .mat-tab-body-content {\r\n//   overflow-x: hidden !important;\r\n// }\r\n\r\n\r\n\r\n.inIcon{\r\n  position: relative;\r\n  top:-15%;\r\n}\r\n\r\n\r\n::ng-deep.mirth_transaction_style .mat-content{\r\n  display: block !important;\r\n}\r\n::ng-deep.mirth_transaction_style{\r\n  transform: none !important;\r\n  height: 65vh !important;\r\n  overflow-y: auto !important;\r\n  overflow-x: hidden !important;\r\n}\r\n\r\n::ng-deep.Mode_Boot .modal-dialog {\r\n  max-width: 97% !important;\r\n  max-height: 100% !important;\r\n  height: 100% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.Mode_Boot {\r\n  top: 3% !important;\r\n  font-family: montserrat;\r\n  font-size: 12px;\r\n  strong{\r\n    font-weight: 600 !important;\r\n  }\r\n}\r\n.fieldstyle{\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%); border-radius: 5px !important;    border: transparent;\r\n  width:98% !important;\r\n  min-height: 50px !important;\r\n  max-height: 50px !important;\r\n  overflow-x: hidden !important;\r\n  overflow-y: auto !important;\r\n  background-color: white !important;\r\n}\r\n  .examplechiplist mat-form-field.mat-form-field.mat-form-field-appearance-fill > div.mat-form-field-wrapper > div.mat-form-field-flex > div.mat-form-field-infix  {\r\n    padding-inline: 5px ;\r\n      padding-block: 1px ;\r\n      padding-top: 0px !important;\r\n      min-height: 40px !important ; }\r\n  .examplechiplist mat-form-field.mat-form-field.mat-form-field-appearance-fill > div.mat-form-field-wrapper > div.mat-form-field-flex > div.mat-form-field-infix > mat-chip-list.mat-chip-list\r\n  {\r\n     display: inline-block;\r\n    }\r\n\r\n  .examplechiplist .mat-form-field-appearance-fill.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {\r\n      transform: translateY(-1.1em) scale(.75);\r\n      width: 133.33333%;\r\n  }\r\n  ::ng-deep.examplechiplist .mat-form-field-infix .mat-chip-list-wrapper{\r\n    padding-top: 15px !important;\r\n    float: left;\r\n  }\r\n  ::ng-deep.examplechiplist2 .mat-mdc-form-field-infix .mat-chip-list-wrapper{\r\n    padding-top: 0px !important;\r\n    float: left;\r\n  }\r\n  ::ng-deep.examplechiplist2 .mat-form-field-appearance-legacy .mat-mdc-text-field-wrapper {\r\n    margin-top: -1% !important;\r\n    margin-left: 2% !important;\r\n     padding-bottom: 0px !important;\r\n  }\r\n  ::ng-deep.examplechiplist .mat-form-field-appearance-legacy .mat-mdc-text-field-wrapper {\r\n    margin-top: -3% !important;\r\n    margin-left: 2% !important;\r\n     padding-bottom: 0px !important;\r\n  }\r\n.matchipinputfield input.mat-chip-input {\r\n  width: 150px;\r\n  margin: 4px;\r\nflex: 1 0 150px;\r\n }\r\n.matchipinputfield2 input.mat-chip-input {\r\n  width: 150px;\r\n  margin: 4px;\r\n  flex: 1 0 150px;\r\n}\r\n.message_feild2{\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    width: 100%;\r\n    float: left;\r\n    height: 5vh;\r\n    font-size: $fontsize;\r\n}\r\n.textFeid{\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    width: 100%;\r\n    height: 16.5vh;\r\n    font-size: $fontsize\r\n}\r\n\r\n.message_feild1{\r\n  float: left;\r\n  font-size: $fontsize;\r\n  height: 9.5vh;\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    width: 100%;\r\n}\r\n.message_feild3{\r\n  float: left;\r\n  font-size: $fontsize;\r\n  height: 15.8vh;\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n  width: 100%;\r\n}\r\n.card_HeightExp\r\n{\r\n  max-height:34vh;\r\n  min-height:34vh;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n.card_HeightCol\r\n{\r\n  max-height: 57vh;\r\n  min-height:57vh;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n.view-btn-details\r\n{\r\n  position: absolute;\r\n  left: 57%;\r\n  width: 84px;\r\n}\r\n::ng-deep .PopupScreen .modal-dialog {\r\n  max-width: 80% !important;\r\n  max-height: 50px !important;\r\n  padding: 0 !important;\r\n  display: flex !important;justify-content: center !important;\r\n}\r\n::ng-deep.myCustomModalViewfile .modal-dialog {\r\n  max-width: 80% !important;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  padding: 0 !important;\r\n  display: flex !important;justify-content: center !important;\r\n}\r\n\r\n\r\n\r\n::ng-deep.archivecheck.mat-mdc-checkbox {\r\n  .mdc-checkbox {\r\n    width: 14px;\r\n    height: 14px;\r\n    padding-right: 6px;\r\n    bottom: 4px;\r\n    .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background{\r\n      border-color: $btn-color;\r\n      background-color: $btn-color;\r\n    }\r\n    .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark {\r\n      color: white;\r\n  }\r\n  }\r\n  .mdc-checkbox__background{\r\n    height: 16px;\r\n    width: 16px;\r\n  }\r\n  .mdc-form-field>label {\r\n    padding-right: 10px;\r\n  }\r\n}\r\n\r\n::ng-deep.msgrep.mat-mdc-checkbox {\r\n  height: 16px;\r\n  width: 16px;\r\n  position: relative;\r\n  right: 3%;\r\n  bottom: 9%;\r\n  .mdc-checkbox {\r\n    width: 16px;\r\n    height: 16px;\r\n    .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background{\r\n      border-color: $btn-color;\r\n      background-color: $btn-color;\r\n    }\r\n    .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark {\r\n      color: white;\r\n  }\r\n  }\r\n  .mdc-checkbox__background{\r\n    height: 16px;\r\n    width: 16px;\r\n  }\r\n}\r\n::ng-deep.msgreplist.mat-mdc-checkbox {\r\n  .mdc-checkbox {\r\n    width: 16px;\r\n    height: 16px;\r\n    .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background{\r\n      border-color: $btn-color;\r\n      background-color: $btn-color;\r\n    }\r\n    .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark {\r\n      color: white;\r\n  }\r\n  }\r\n  .mdc-checkbox__background{\r\n    height: 16px !important;\r\n    width: 16px !important;\r\n  }\r\n}\r\n.copylabel{\r\n  position: relative;\r\n    bottom: 8px;\r\n}\r\n\r\n::ng-deep.messageioteditor .editor-container{\r\n  .monaco-editor{\r\n    width: 100% !important;\r\n    .overflow-guard{\r\n      width: 100% !important;\r\n      .monaco-scrollable-element.editor-scrollable{\r\n        width: 85% !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n::ng-deep.messageioteditormax .editor-container{\r\n  .monaco-editor{\r\n    width: 100% !important;\r\n    .overflow-guard{\r\n      width: 100% !important;\r\n      .monaco-scrollable-element.editor-scrollable{\r\n        width: 92% !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n::ng-deep.viewstages .modal-dialog {\r\n  max-width: 97% !important;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.viewstages {\r\n  top: 4% !important;\r\n}\r\n::ng-deep.viewstages {\r\n  top: 4% !important;\r\n  font-family: 'Montserrat', sans-serif;\r\n  font-size: 11px;\r\n\r\n  strong {\r\n    font-weight: 600 !important;\r\n  }\r\n}\r\n.button-container {\r\n  display: flex; \r\n  justify-content: flex-start; \r\n  align-items: center; \r\n  gap: 15px; \r\n  padding: 10px; \r\n  width: 100%; \r\n}\r\n\r\n.icon-button {\r\n  display: flex; \r\n  align-items: center; \r\n  justify-content: center; \r\n  background-color: transparent; \r\n  color: #4caf50; \r\n  border: none; \r\n  cursor: pointer; \r\n  position: relative;\r\n  transition: transform 0.2s; \r\n}\r\n\r\n.icons_list_style {\r\n  background-color: transparent; \r\n}\r\n\r\n.icons_list_style_active {\r\n  background-color: transparent; \r\n}\r\n\r\n.icon-button.icons_list_style_active::after {\r\n  content: \"\"; \r\n  position: absolute; \r\n  bottom: -5px; \r\n  left: 0; \r\n  right: 0; \r\n  height: 3px; \r\n  background-color: #00bcd4; \r\n  border-radius: 5px; \r\n}\r\n\r\n.text-truncate {\r\n  white-space: nowrap; \r\n  overflow: hidden;\r\n  text-overflow: ellipsis; \r\n}\r\n\r\n.mirthsuc {\r\n  font-weight: normal; \r\n  display: inline; \r\n  margin-left: 2px;\r\n  max-width: 220px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.col-sm-4 {\r\n  padding: 10px; \r\n}\r\n\r\n.div-message-attributes {\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  width: 100%;\r\n  color: black; \r\n}\r\n.mt-minus-3 {\r\n  margin-top: -2vh;\r\n}\r\n\r\n\r\n.icon-style {\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  margin-top: -9px;\r\n  margin-right: 16px;\r\n  font-size: 27px;\r\n}\r\n\r\n\r\n.icon-styles {\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  margin-bottom: 2px;\r\n  margin-top: -12px;\r\n  margin-right: 16px;\r\n  height: 20px;\r\n  width: 20px;\r\n}\r\n\r\n.icon-ack {\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  margin-bottom: 2px;\r\n  margin-top: -6px; \r\n  margin-right: 15px;\r\n  height: 25px;\r\n  width: 22px;\r\n}\r\n\r\n.icon-hold {\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  margin-bottom: 2px;\r\n  margin-top: 3px;\r\n  margin-right: 16px;\r\n  font-size: 21px;\r\n  width: 20px;\r\n}\r\n\r\n.clickable-div {\r\n  cursor: pointer; \r\n}\r\n\r\n.clickable-div button,\r\n.clickable-div mat-icon,\r\n.clickable-div i,\r\n.clickable-div img,\r\n.clickable-div svg,\r\n.clickable-div td {\r\n  cursor: pointer !important;\r\n}\r\n.redirectlink{\r\n  white-space: nowrap;  position: relative; z-index: 1000;\r\n  color: #4b86b2;\r\n}\r\n.redirectlink:hover{\r\n  background-color: #3fa4fb;\r\n    border-radius: 12px;\r\n    color: white;\r\n    padding: 3px;\r\n    cursor: pointer;\r\n    white-space: nowrap;\r\n    position: relative; z-index: 1000;\r\n}\r\n.childexpcard{\r\n  background-color:#f9f9f9; \r\n  margin-bottom: 0; \r\n  padding-top: 5px;\r\n  min-height: 13vh;\r\n  max-height: 23vh;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n::ng-deep.main_page_paginator{\r\n  .mat-mdc-paginator-container{\r\n    min-height: 40px !important;\r\n    max-height: 40px !important;\r\n  }\r\n}","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
